function notEqualityValidator({ configs, fieldValues, fields, input, msgs }) {
  const field = fields[configs.clientId];
  const value = fieldValues[configs.clientId];

  if (field && value && input && value.toLowerCase() === input.toLowerCase()) {
    return msgs && msgs.msg;
  }

  return null;
}

export default notEqualityValidator;
